import React from 'react';

import classes from './Spinner.module.css';

const Spinner = (props) => {
	return (
		<div className={classes.CenterSpinner}>
			<div className={classes.Spinner}></div>
		</div>
	);
};

export default Spinner;
